// ERRORS-1 Part B: app-wide "Report a bug" context. `BugReportProvider`
// (components/BugReportProvider.tsx) owns the one dialog; anything below it (the shell's
// "Report a bug", `RecordingProblem`'s "Report this problem") opens it via `useBugReport()`,
// optionally prefilled with the failing recording + code. Outside a provider, or with the flag
// off, `useBugReport()` returns null and callers hide their report affordance.
import { createContext, useContext } from 'react';
import type { ProblemArea } from '@scribe/core/errors';

export interface BugReportPrefill {
  recordingId?: string | null;
  failureCode?: string | null;
  area?: ProblemArea;
  /** Shown as a starting point in "What happened" — the catalogue title, never user content. */
  summary?: string;
}

export interface BugReportContextValue {
  open: (prefill?: BugReportPrefill) => void;
}

export const BugReportContext = createContext<BugReportContextValue | null>(null);

export function useBugReport(): BugReportContextValue | null {
  return useContext(BugReportContext);
}
